import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const IMPRESSUM_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/impressum-carousel/impressum-carousel.component').then(mod => mod.ImpressumCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/impressum-home/impressum-home.component').then(mod => mod.ImpressumHomeComponent),
        title: 'YSTM - Impressum',
        data: {
            meta: {
                description: 'Impressum der Web-Site ystm.eu'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];